/* eslint object-curly-newline: */
import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Panel,
  Row,
  Table,
  Glyphicon
} from 'react-bootstrap';
import ConditionalComponent from './ConditionalComponent';
import ActionButtonListComponent from './ActionButtonListComponent';
import DragSelectComponent from './DragSelectComponent';

const buildTable = ({
  actionsById,
  issues,
  issueTypesById,
  onAckSingle,
  onActionButtonClick,
  onSelectionComplete,
  sort,
  setSort,
  jobLinksById }) => {
  if (issues.length === 0) {
    return null;
  }

  const sortableColumnHeader = { cursor: 'pointer' };
  const sortableColumns = [
    {
      columnTitle: 'Issue',
      sortableProperty: 'issue_id'
    },
    {
      columnTitle: 'Node',
      sortableProperty: 'node_name'
    },
    {
      columnTitle: 'Job Name',
      sortableProperty: 'job_name'
    },
    {
      columnTitle: 'Job Number',
      sortableProperty: 'job_number'
    },
  ];
  const holdKey = 'ctrl';
  const rowIssues = issues &&
  (sort ? issues.sort((a, b) => (a[sort] > b[sort]) - (a[sort] < b[sort])) : issues);

  const rows = issues && rowIssues.map(i => {
    return (
      <tr
        key={i.id}
        className={'row-draggable'}
        data-id={i.id}
      >
        <th>&nbsp;</th>
        <td>{i.issue_id}: {issueTypesById[i.issue_id].friendly}</td>
        <td>{i.node_name || ''}</td>
        <td>{i.job_name || ''}</td>
        <td>
          <a
            className={'hidden-link'}
            href={jobLinksById[i.id]}
          >
            {i.job_number || ''}
          </a>
        </td>
        <td>
          <ActionButtonListComponent
            actions={actionsById[i.id]}
            onButtonClick={onActionButtonClick}
            itemId={i.id}
          />

        </td>
        <td>
          <Button
            id={`ack-${i.job_name}-${i.job_number}-btn`}
            onClick={() => onAckSingle(i.id)}
          >
            Ack
          </Button>
        </td>
      </tr>
    );
  });
  return (
    <div>
      <DragSelectComponent
        dragContainer={'.drag-select-area'}
        selectableTargets={['.row-draggable']}
        hitDetectionPercentile={1}
        continueSelectKey={holdKey}
        onSelectionComplete={(e) => {
          // selected property will hold array of table cells selected
          // we only care about the data they hold
          const dataArray = e.selected.map(td => td.dataset);

          onSelectionComplete(dataArray);
        }}
      />
      <Table className={'drag-select-area'}>
        <thead>
          <tr>
            <th>Details</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            {sortableColumns.map(col => {
              const key = `${col.sortableProperty}-details-header`;
              return (
                <th key={key} id={key}
                  style={sortableColumnHeader} onClick={
                    () => setSort(col.sortableProperty)}
                >
                  {col.columnTitle}
                  {sort === col.sortableProperty ?
                    <Glyphicon
                      glyph="chevron-down"
                    /> : null}
                </th>
              ); }
            )}
            <th>Actions</th>
            <th>&nbsp;</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    </div>
  );
};
buildTable.propTypes = {
  actionsById: PropTypes.object.isRequired,
  issues: PropTypes.array.isRequired,
  issueTypesById: PropTypes.object.isRequired,
  onAckSingle: PropTypes.func.isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  onSelectionComplete: PropTypes.func,
  sort: PropTypes.string.isRequired,
  setSort: PropTypes.func.isRequired,
  jobLinksById: PropTypes.array.isRequired
};

const NodeHealthDetailsComponent = (props) => {
  const [detailsSort, setDetailsSort] = useState('');

  const table = buildTable({
    ...props,
    issues: props.selectedNodeIssues,
    sort: detailsSort,
    setSort: setDetailsSort
  });

  return (
    <div>
      <Row>
        <Col>
          <Panel bsStyle={'primary'} style={{ marginLeft: '2%', marginRight: '2%' }}>
            <Panel.Heading>
              <Panel.Title>
                {'Selection Details'}
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <div>
                <Row>
                  <ConditionalComponent condition=
                    {props.selectedNodeIssues.length !== 0 &&
                      props.selectedNodeIssuesForAck.length === 0}
                  >
                    <Button
                      id={'ack-all-btn'}
                      style={{ marginLeft: '2%', marginBottom: '2%' }}
                      onClick={() => {
                        const allIds = props.selectedNodeIssues.map(i => i.id);
                        props.onAckMultiple(allIds);
                      }}
                    >
                      Ack All
                    </Button>
                  </ConditionalComponent>
                  <ConditionalComponent condition={
                    props.selectedNodeIssuesForAck.length !== 0
                  }
                  >
                    <Button
                      id={'ack-selected-btn'}
                      style={{ marginLeft: '2%', marginBottom: '2%' }}
                      onClick={() => {
                        props.onAckMultiple(props.selectedNodeIssuesForAck);
                        props.onSelectionComplete([]);
                      }}
                    >
                      Ack Selected
                    </Button>
                  </ConditionalComponent>
                </Row>
                {table || 'Nothing Selected'}
              </div>
            </Panel.Body>
          </Panel>
        </Col>
      </Row>
    </div>
  );
};

NodeHealthDetailsComponent.propTypes = {
  actionsById: PropTypes.object.isRequired,
  issueTypesById: PropTypes.object.isRequired,
  selectedNodeIssues: PropTypes.array.isRequired,
  selectedNodeIssuesForAck: PropTypes.array.isRequired,
  onAckSingle: PropTypes.func.isRequired,
  onAckMultiple: PropTypes.func.isRequired,
  onActionButtonClick: PropTypes.func.isRequired,
  onSelectionComplete: PropTypes.func
};

export default NodeHealthDetailsComponent;




// WEBPACK FOOTER //
// src/Components/NodeHealthDetailsComponent.jsx